import ProgressPage from '@app-studio-web/ui/pages/ProgressPage'

export default function CraftingProgressPage() {
  return (
    <ProgressPage
      emoji="🚀"
      title="pages.onboarding.craftingProgress.title"
      subtitle="pages.onboarding.craftingProgress.subtitle"
      progressBarSubtitle="pages.onboarding.craftingProgress.progressBarSubtitle"
      durationMs={1500}
    />
  )
}
